import { z } from 'zod';

import { MenuLinkType } from '@nucleus-commerce/api-client/admin';

/** One menu item as its dialog edits it; the backend's rules for url and target links. */
export const menuItemFormSchema = z
  .object({
    title: z
      .string()
      .trim()
      .min(1, { error: 'menus:validation.itemTitleRequired' })
      .max(120, { error: 'menus:validation.itemTitleLength' }),
    linkType: z.enum(MenuLinkType),
    url: z.string().trim().max(1000, { error: 'menus:validation.urlLength' }),
    targetId: z.string().nullable(),
    openInNewTab: z.boolean(),
  })
  .superRefine((item, ctx) => {
    if (item.linkType === 'url') {
      if (!item.url) {
        ctx.addIssue({ code: 'custom', path: ['url'], message: 'menus:validation.urlRequired' });
      } else if (!item.url.startsWith('/') && !item.url.startsWith('https://')) {
        ctx.addIssue({ code: 'custom', path: ['url'], message: 'menus:validation.urlFormat' });
      }
    } else if (!item.targetId) {
      ctx.addIssue({
        code: 'custom',
        path: ['targetId'],
        message: 'menus:validation.targetRequired',
      });
    }
  });

export type MenuItemForm = z.infer<typeof menuItemFormSchema>;
